export default "__VITE_ASSET__3goV6QA6__"